export default "__VITE_ASSET__BBnSMtmH__"